import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  iconColor?: "primary" | "secondary" | "accent";
  actions?: ReactNode;
  showBackButton?: boolean;
}

export function PageHeader({
  title,
  subtitle,
  icon,
  iconColor = "primary",
  actions,
  showBackButton = true,
}: PageHeaderProps) {
  const navigate = useNavigate();

  const iconBgColors = {
    primary: "bg-primary/10",
    secondary: "bg-secondary/10",
    accent: "bg-accent/10",
  };

  const iconTextColors = {
    primary: "text-primary",
    secondary: "text-secondary",
    accent: "text-accent",
  };

  return (
    <div className="mb-8">
      {showBackButton && (
        <div className="mb-4">
          <Button
            variant="ghost"
            onClick={() => navigate("/dashboard")}
            className="gap-2 text-muted-foreground hover:text-foreground"
          >
            <Home className="w-4 h-4" />
            Accueil
          </Button>
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-4">
          {icon && (
            <div
              className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl ${iconBgColors[iconColor]} flex items-center justify-center shrink-0`}
            >
              <div className={`${iconTextColors[iconColor]}`}>{icon}</div>
            </div>
          )}
          <div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font-cinzel text-foreground">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm sm:text-base text-muted-foreground mt-1">
                {subtitle}
              </p>
            )}
          </div>
        </div>

        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
    </div>
  );
}
